import React                         from 'react';
import _                             from 'underscore';
import { Align, CorvalAccount }      from "@src/types";
import { Header, Icon, List, Popup } from "semantic-ui-react";
import { Cell, Grid }                from "styled-css-grid";


import { StyledContainer }     from "@src/views/containers";
import { useSystemData }       from '@src/hooks/useSystemData';
import { FinePrintMessage }    from "../util/messaging/FinePrintMessage";
import { BusinessFunctionDot } from "../product/BusinessFunctionDot";
import { UserAvatar }          from "../user-avatar/UserAvatar";


interface OrganizationUserBusinessFunctionSupportListItemProps {
    user: CorvalAccount,
    withEmailLink?: boolean,
    emailSubject?: string,
}

const OrganizationUserBusinessFunctionSupportListItemDefaultProps = {
    user: null,
} satisfies Partial<OrganizationUserBusinessFunctionSupportListItemProps>;

function OrganizationUserBusinessFunctionSupportListItem( p: OrganizationUserBusinessFunctionSupportListItemProps ){

    const props = { ...OrganizationUserBusinessFunctionSupportListItemDefaultProps, ...p };

    const systemData = useSystemData();

    let emailAddress = props.user.emailAddress,
        emailsubject = props.emailSubject ?? '';

    return (

        <Popup position={ 'top center' }
               content={ (
                   <StyledContainer textAlign={ Align.LEFT }>

                       <Header as={ 'h5' } icon={ 'user' } content={ 'User Support' }/>
                       <FinePrintMessage as={ 'span' }>{ props.user.firstName } can support decisions in the following functional business areas:</FinePrintMessage>
                       <List>
                           { props.user.businessFunctions.map( businessFunctionId => {

                               const businessFunction = _.findWhere( systemData.businessFunctions, { id: businessFunctionId } );

                               return (
                                   <List.Item key={ businessFunctionId }>
                                       <BusinessFunctionDot size={ 10 } businessFunction={ businessFunction }/>{ ' ' }{ businessFunction.name }
                                   </List.Item>
                               );

                           } ) }
                       </List>
                   </StyledContainer>
               ) }
               trigger={ (

                   <Grid columns={ `1fr auto` } rowGap={ '0px' } columnGap={ '0px' } className={ 'cursor--pointer' }>

                       <Cell middle>

                           <UserAvatar user={ props.user } asInitials={ true } withName={ true }/>

                       </Cell>
                       <Cell middle className={ 'text-right' }>
                           <List horizontal divided>
                               <List.Item>
                                   <a href={ `mailto:${ emailAddress }?subject=${ emailsubject }` }>
                                       <Icon name={ 'envelope' } color={ 'purple' } fitted/>
                                   </a>
                               </List.Item>
                           </List>

                       </Cell>
                   </Grid>

               ) }/>
    );
}

export {
    OrganizationUserBusinessFunctionSupportListItem,
    OrganizationUserBusinessFunctionSupportListItemDefaultProps,
    type OrganizationUserBusinessFunctionSupportListItemProps,
};
